import { gql } from '@apollo/client';
import { MeetingPlacePageTenantShopItemMinifiedFragment } from './meetingPlacePageTenantShopItem';
import { LibraryOfferTypeFragment } from './LibraryOfferType';
import { MeetingPlacePageTenantEntertainmentItemMinifiedFragment } from './meetingPlacePageTenantEntertainmentItem';
import { LibraryBrandFoodBeverageMinifiedFragment } from './libraryBrandFoodBeverage';
import { MeetingPlacePageTenantFoodBevItemMinifiedFragment } from './meetingPlacePageTenantFoodBevItem';
import { LibraryBrandShopMinifiedFragment } from './libraryBrandShop';
import { LibraryBrandEntertainmentMinifiedFragment } from './libraryBrandEntertainment';
import { LibraryCategoryFoodBeverageFragment } from './libraryCategoryFoodBeverage';
import { LibraryCategoryShopFragment } from './libraryCategoryShop';
import { LibraryCategoryEntertainmentFragment } from './libraryCategoryEntertainment';

export interface IMeetingPlacePageOfferItem {
  __typename: string;
  sys: {
    id: string;
  };
  contentful_id: string;
  name: string;
  caption: string;
  slug: string;
  updatedAt?: string | Date;
  createdAt?: string | Date;
  offerCampaignTagsCollection: {
    items: {
      tagName: string;
      colour: string;
      type: string;
    }[];
  };
  date: string;
  validFrom: any;
  validTo: any;
  body: any;
  coverImage: any;
  tenant: any;
  // customizedSlug: string;
  // node_locale: string;
  seoDescription: any;
  categories?: any;
  typeOfOffer: any;
  offerRedemptionMechanism: string;
  offerRedemptionDetails?: {
    internalName: string;
    richText: any;
  };
  beResourceId?: string;
  livliFamily?: string;
  priority?: number | null;
}

export const MeetingPlacePageCoreOfferItemFragment = gql`
  ${LibraryOfferTypeFragment}
  fragment MeetingPlacePageCoreOfferItem on MeetingPlacePageOffer {
    __typename
    sys {
      id
    }
    slug
    name
    caption
    seoDescription
    offerCampaignTagsCollection(limit: 2) {
      items {
        tagName
        colour
        type
      }
    }
    date
    validFrom
    validTo
    typeOfOffer {
      ...LibraryOfferType
    }
    body {
      json
    }
    coverImage {
      description
      url
      height
      width
    }
    offerRedemptionMechanism
    beResourceId
    offerRedemptionDetails {
      internalName
      richText {
        json
        links {
          assets {
            block {
              sys {
                id
              }
              height
              width
              url
            }
            hyperlink {
              sys {
                id
              }
              height
              width
              url
            }
          }
        }
      }
    }
  }
`;

export const MeetingPlacePageTenantOfferItemFragment = gql`
  ${LibraryBrandShopMinifiedFragment}
  ${LibraryBrandEntertainmentMinifiedFragment}
  ${LibraryBrandFoodBeverageMinifiedFragment}
  ${LibraryCategoryFoodBeverageFragment}
  ${LibraryCategoryShopFragment}
  ${LibraryCategoryEntertainmentFragment}
  fragment MeetingPlacePageTenantOfferItem on MeetingPlacePageOffer {
    __typename
    sys {
      id
    }
    tenant {
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          sys {
            id
          }
          shopId
          brand {
            ...LibraryBrandShopMinified
          }
          name
          slug
          logo {
            description
            url
            height
            width
          }
          primaryCategory {
            ...LibraryCategoryShop
          }
          secondaryCategoriesCollection(limit: 10) {
            items {
              ...LibraryCategoryShop
            }
          }
        }
        ... on MeetingPlacePageTenantEntertainment {
          sys {
            id
          }
          shopId
          brand {
            ...LibraryBrandEntertainmentMinified
          }
          name
          logo {
            description
            url
            height
            width
          }
          primaryCategory {
            ...LibraryCategoryEntertainment
          }
          secondaryCategoriesCollection(limit: 10) {
            items {
              ...LibraryCategoryEntertainment
            }
          }
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          sys {
            id
          }
          shopId
          brand {
            ...LibraryBrandFoodBeverageMinified
          }
          name
          logo {
            description
            url
            height
            width
          }
          primaryCategory {
            ...LibraryCategoryFoodBeverage
          }
          secondaryCategoriesCollection(limit: 10) {
            items {
              ...LibraryCategoryFoodBeverage
            }
          }
        }
      }
    }
  }
`;

export const MeetingPlacePageOfferListItemFragment = gql`
  ${MeetingPlacePageTenantShopItemMinifiedFragment}
  ${MeetingPlacePageTenantEntertainmentItemMinifiedFragment}
  ${LibraryOfferTypeFragment}
  ${MeetingPlacePageTenantFoodBevItemMinifiedFragment}
  fragment MeetingPlacePageOfferListItem on MeetingPlacePageOffer {
    __typename
    sys {
      id
    }
    name
    slug
    coverImage {
      description
      url
      height
      width
    }
    typeOfOffer {
      ...LibraryOfferType
    }
    offerCampaignTagsCollection(limit: 2) {
      items {
        tagName
        colour
        type
      }
    }
    date
    validFrom
    validTo
    priority
    tenant {
      __typename
      ... on _Node {
        ... on MeetingPlacePageTenantShop {
          ...MeetingPlacePageTenantShopItemMinified
        }
        ... on MeetingPlacePageTenantEntertainment {
          ...MeetingPlacePageTenantEntertainmentItemMinified
        }
        ... on MeetingPlacePageTenantFoodBeverage {
          ...MeetingPlacePageTenantFoodBevItemMinified
        }
      }
    }
  }
`;

